import React, { useEffect } from "react";
import Html from "utils/Html";
import { Dropdown } from "semantic-ui-react";
import { useAlluser } from "context/AlluserContext";

export default function FilterJobFunction({ data }) {
  const { filters, storeFilters } = useAlluser();
  const filterName = "jobfunction";
  const filterTitle = "Job Function";

  let handleEvents = {
    SelectNone: {
      OnClick: function (evt) {
        let selectedArr = [];
        // console.log("Btn Select None => " + filterName);
        storeFilters({ ...filters, jobfunction: selectedArr });
      },
    },
    SelectAll: {
      OnClick: function (evt) {
        let selectedArr = [];
        for (const i in data) {
          selectedArr.push(data[i].job_id);
        }
        // console.log("Btn Select All => " + filterName, selectedArr);
        storeFilters({ ...filters, jobfunction: selectedArr });
      },
    },
    OnChange: function (evt, { name, value }) {
      // console.log(name, value);
      storeFilters({ ...filters, jobfunction: value });
    },
  };

  useEffect(() => {}, []);

  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <Html.SelectAll handleEvents={handleEvents} />
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={true}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(data, {
          id: "",
          key: filterName,
          name: "job_name",
          value: "job_id",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.jobfunction ?? []}
        onChange={handleEvents.OnChange}
        disabled={false}
        className="alluser-dropdown"
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
